import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { prettyDate } from '@/helpers/date';
import { prettyFloatMoney } from '@/helpers/utils';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import IconChevron from './icon_chevron.svg';
import IconCheck from './icon_check.svg';
import IconShift from './icon_calendar.svg';
import IconArrow from './icon_arrow.svg';
import s from './index.module.scss';

export const PaymentSelect = ({ selected, options, onChange }) => {
  const ref = useRef();
  const { t } = useTranslation('modal');
  const [open, setOpen] = useState(false);
  useOutsideClick(ref, () => setOpen(false), open);

  const handleChange = payment => {
    onChange(payment);
    setOpen(false);
  };

  const scheduled = (
    <>
      <img src={IconShift} alt="scheduled" width={16} height={16} style={{ minWidth: '16px' }} />
      {t('shift_payment_modal.scheduled')}
    </>
  );

  const shifted = desc => (
    <>
      <img src={IconArrow} alt="arrow" width={16} height={16} style={{ minWidth: '16px' }} />
      {desc}
    </>
  );

  return (
    <div className={s.wrapper} ref={ref}>
      <div className={s.select} onClick={() => setOpen(!open)}>
        <div className={s.content}>
          <div className={s.row}>
            <div className="f-body-medium">{prettyDate(selected.deadline, 'D MMMM YYYY')}</div>
            <div className={s.dot} />
            <div className="f-body-medium">{prettyFloatMoney(selected.amount)}</div>
          </div>
          <div className={classnames('f-label', s.desc)}>
            {selected.description ? shifted(selected.description) : scheduled}
          </div>
        </div>
        <img src={IconChevron} width={20} height={20} alt="chevron" style={{ minWidth: '20px' }} />
      </div>
      {open && (
        <div className={s.menu}>
          <div className={s.menu_inner}>
            {options.map(option => (
              <div
                key={option.original_deadline}
                onClick={() => handleChange(option)}
                className={classnames(
                  s.option,
                  selected.original_deadline === option.original_deadline && s.option_selected,
                )}
              >
                <div className={s.content}>
                  <div className={s.row}>
                    <div className="f-body-medium">
                      {prettyDate(option.deadline, 'D MMMM YYYY')}
                    </div>
                    <div className={s.dot} />
                    <div className="f-body-medium">{prettyFloatMoney(option.amount)}</div>
                  </div>
                  <div className={classnames('f-label', s.desc)}>
                    {option.description ? shifted(option.description) : scheduled}
                  </div>
                </div>
                {option.original_deadline === selected.original_deadline && (
                  <img
                    src={IconCheck}
                    alt="check"
                    width={24}
                    height={24}
                    style={{ minWidth: '20px' }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
